import {
  api_get_assign_process_list_url,
  api_create_assign_process_url,
  api_update_assign_process_url,
  api_activate_deactivate_assign_process_url,
  api_get_assign_process_details_url,
  api_get_sidebar_menu_list_url
} from "./assignprocessApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  parser_get_assign_process_list,
  parser_create_assign_process,
  parser_update_assign_process,
  parser_activate_deactivate_assign_process,
  parser_get_assign_process_details,
  parser_get_sidebar_menu_list
} from "./assignprocessParser";
import { PAGE } from "../../helpers/constants";

export const get_assign_process_list = createAsyncThunk(
  "assign_process",
  async (payload) => {
    try {
      const { page, limit, qn, qs, kc } = payload;
      const response = await api_get_assign_process_list_url(page, limit, qn, qs, kc);
      const data = parser_get_assign_process_list(response);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  }
);


export const create_assign_process = createAsyncThunk(
  "create_assign_process",
  async (payload) => {
    try {
      const response = await api_create_assign_process_url(payload);
      const data = parser_create_assign_process(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const update_assign_process = createAsyncThunk(
  "update_assign_process",
  async (payload) => {
    try {
      const { assign_process_id, updated_data } = payload
      // Send updated_data as JSON
      const response = await api_update_assign_process_url(assign_process_id, updated_data);
      const data = parser_update_assign_process(response);
      return { data };
    } catch (error) {
      throw new Error(error.message || "Failed to update assign process");
    }
  }
);

export const activate_deactivate_assign_process = createAsyncThunk(
  "activate_deactivate_assign_process",
  async (payload) => {
    try {
      const { assign_process_id, updated_data } = payload
      const response = await api_activate_deactivate_assign_process_url(assign_process_id, updated_data)
      const data = parser_activate_deactivate_assign_process(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_assign_process_details = createAsyncThunk(
  "get_assign_process_details",
  async (payload) => {
    try {
      const response = await api_get_assign_process_details_url(payload);
      const data = parser_get_assign_process_details(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_sidebar_menu_list = createAsyncThunk(
  "get_sidebar_menu_list",
  async () => {
    try {
      const response = await api_get_sidebar_menu_list_url();
      const data = parser_get_sidebar_menu_list(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  common_loading: false,
  is_assign_process_modal_open: false,
  selected_status: '',
  search_query: '',
  selected_data: null,
  c_action: null,
  assign_process_id: null,
  assign_process_list: [],
  total_assign_process_count: 0,
  active_assign_process: 0,
  page: PAGE - 1,
  sidebar_menu_list: []
};

export const assignProcessSlice = createSlice({
  name: "assignProcess",
  initialState,
  reducers: {
    setAssignProcessPage: (state, action) => {
      state.page = action.payload;
    },
    setAssignProcessModalOpen: (state, action) => {
      state.is_assign_process_modal_open = action.payload;
    },
    setAction: (state, action) => {
      state.c_action = action.payload;
    },
    setId: (state, action) => {
      state.assign_process_id = action.payload;
    },
    setStatus: (state, action) => {
      state.selected_status = action.payload ? action.payload : '';
    },
    setSearchQuery: (state, action) => {
      state.search_query = action.payload;
    }
  },
  extraReducers: (builder) => {
    // get list
    builder.addCase(get_assign_process_list.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_assign_process_list.fulfilled, (state, action) => {
      state.common_loading = false;
      const data = Array.isArray(action.payload.assign_to_process) ? action.payload.assign_to_process : [];
      state.assign_process_list = data;
      state.total_assign_process_count = action.payload.total_count || data.length;
      state.active_assign_process = data.filter(item => item.is_active).length;
    })
    builder.addCase(get_assign_process_list.rejected, (state) => {
      state.common_loading = false;
    })
    //create
    builder.addCase(create_assign_process.fulfilled, (state, action) => {
      state.common_loading = false;
      if (action.payload?.data) {
        state.assign_process_list.push(action.payload.data);
        state.total_assign_process_count = state.assign_process_list.length;
        state.active_assign_process = state.assign_process_list.filter(item => item.is_active).length;
      }
    });
    //update process
    builder.addCase(update_assign_process.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(update_assign_process.fulfilled, (state, action) => {
      state.common_loading = false;
      // Rely on re-fetch to update the list to avoid stale names
      // state.assign_process_list = state.assign_process_list.map((item) =>
      //   item.id === action.payload.data.id ? { ...item, ...action.payload.data } : item
      // );
    })
    builder.addCase(update_assign_process.rejected, (state) => {
      state.common_loading = false;
    })
    // activate_deactivate
    builder.addCase(activate_deactivate_assign_process.fulfilled, (state, action) => {
      state.common_loading = false;
      state.assign_process_list = state.assign_process_list.map((item) =>
        item.id === action.payload.data.id ? { ...item, ...action.payload.data } : item
      );
      state.total_assign_process_count = state.assign_process_list.length;
      state.active_assign_process = state.assign_process_list.filter(item => item.is_active).length;
    });
    //get details
    builder.addCase(get_assign_process_details.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_assign_process_details.fulfilled, (state, action) => {
      state.common_loading = false;
      state.selected_data = action.payload.data
    })
    builder.addCase(get_assign_process_details.rejected, (state) => {
      state.common_loading = false;
    })
    // get sidebar menu list
    builder.addCase(get_sidebar_menu_list.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_sidebar_menu_list.fulfilled, (state, action) => {
      state.common_loading = false;
      state.sidebar_menu_list = action.payload.data;
    })
    builder.addCase(get_sidebar_menu_list.rejected, (state) => {
      state.common_loading = false;
    })
  },
});

export const {
  setAssignProcessModalOpen,
  setAssignProcessPage,
  setAction,
  setId,
  setStatus,
  setSearchQuery
} = assignProcessSlice.actions;
export default assignProcessSlice.reducer; 